<template>
	<div class="main-footer">
		<div class="site-copyright">
			<p class="site-copyright__text">
				&copy; Copyright {{ actualYear }} - Dominion DMS
			</p>
		</div>
	</div>
</template>

<script>
export default {
	name: 'FooterBar',
	computed: {
		actualYear() {
			return new Date().getFullYear();
		}
	}
};
</script>

<style lang="scss" scoped>
/**
    * Main Footer
	* Can use SCSS variables = TRUE
*/

/*------------------------------------*\
  #COPYRIGHT
\*------------------------------------*/

.site-copyright {
	text-align: right;
}

.site-copyright__text {
	font-size: $default-font-size - 5;
}

/*------------------------------------*\
  #MAIN FOOTER
\*------------------------------------*/

.main-footer {
	padding: $padding-md 0;
	margin-left: $gutter-md; //matches header
	margin-right: $gutter-md; //matches header

	@include mq($from: lg) {
		@include contain(1200px);
	}
}
</style>
